import { render, staticRenderFns } from "./LoadingComponent.vue?vue&type=template&id=fd001066&"
import script from "./LoadingComponent.vue?vue&type=script&lang=js&"
export * from "./LoadingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/projects/zp-front-up/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd001066')) {
      api.createRecord('fd001066', component.options)
    } else {
      api.reload('fd001066', component.options)
    }
    module.hot.accept("./LoadingComponent.vue?vue&type=template&id=fd001066&", function () {
      api.rerender('fd001066', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/LoadingComponent.vue"
export default component.exports